import React, { useState, useEffect } from 'react'
import { AlertProvider } from './erp26/context/AlertContext';
import { useAuth } from './erp26/context/AuthContext'
import { Route, Routes } from 'react-router'

import AdminRoutes from './erp26/routes/AdminRoutes'
import AuthRoutes from './erp26/routes/AuthRoutes'

import LogoutPage from './erp26/app/auth/pages/LogoutPage';
import RechargePage from './erp26/app/admin/business/pages/RechargePage';
import SuspendPage from './erp26/app/admin/business/pages/SuspendPage';
import ManagerRoutes from './erp26/routes/ManagerRoutes';
import Error404Page from './erp26/app/errorPages/Error404Page';
import Error401Page from './erp26/app/errorPages/Error401Page';
import ChangePasswordPage from './erp26/app/auth/pages/ChangePasswordPage';
import { AppDataProvider } from './erp26/context/AppDataContext';
import { AppESSDataProvider } from './erp26/context/AppESSDataContext';
import EssRoutes from './erp26/routes/EssRoutes';
import 'leaflet/dist/leaflet.css';
import FinanceRoutes from './erp26/routes/FinanceRoutes';

function App() {
    const {isLoggedIn,authUser} = useAuth();
    //console.log("authUSerrole", authUser)
    sessionStorage.removeItem("businessInfo");

    // Disable Right Click Start
    useEffect(() => {
        const handleContextmenu = e => {
            e.preventDefault()
        }
        document.addEventListener('contextmenu', handleContextmenu)
        return function cleanup() {
            document.removeEventListener('contextmenu', handleContextmenu)
        }
    }, [])
    // Disable Right Click End
    
    return (
        <>
        <AlertProvider>
            {isLoggedIn ? 
                <>
                    <AppDataProvider>
                    { authUser.role <= 2 &&
                        <AdminRoutes/>
                    }

                    { authUser.role == 3 &&
                        <FinanceRoutes/>
                    }

                    { authUser.role == 4 &&
                        <AppESSDataProvider>
                            <EssRoutes/>
                        </AppESSDataProvider>
                    }


                    
                    <Routes>
                        {/*Logout */}
                        <Route path="/admin/recharge-page" element={<RechargePage />}></Route>
                        <Route path="/admin/suspend-page" element={<SuspendPage />}></Route>
                        <Route path="/auth/logout" element={<LogoutPage/>}></Route>
                        <Route path="/auth/change-password" element={<ChangePasswordPage />}></Route>
                        <Route path="/404" element={<Error404Page/>}></Route>
                        <Route path="/401" element={<Error401Page/>}></Route>
                    </Routes>

                    </AppDataProvider>
                </>
                :
                <AuthRoutes/>
            }
        </AlertProvider>
        </>
    )
}
export default App